import _defineProperty from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import nextStep from '@/components/nextStep/nextStep.vue';
import elSelectCityChose from '@/components/elSelectCityChose/elSelectCityChose.vue';
import applySuccess from './applySuccess.vue';
import { mapState, mapMutations } from 'vuex';
export default {
  components: {
    nextStep: nextStep,
    applySuccess: applySuccess,
    elSelectCityChose: elSelectCityChose
  },
  data: function data() {
    var _this = this,
        _rules;

    var agencyOperatorPhone = function agencyOperatorPhone(rule, value, callback) {
      if (value == '') {
        callback();
      } else {
        var phone = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;

        if (!phone.test(value)) {
          callback(new Error('手机号格式不正确'));
        } else {
          callback();
        }
      }
    };

    var GuaranteeDeadline = function GuaranteeDeadline(rule, value, callback) {
      if (value == '') {
        callback(new Error('保函购买截止时间'));
      } else {
        if (new Date(_this.ruleForm.tenderIsclosedTime).getTime() < new Date(value).getTime()) {
          callback(new Error('投标文件截止时间要超过保函购买截止时间'));
        } else if (new Date().getTime() > new Date(value).getTime()) {
          callback(new Error('请选择当天之后，不能选择当天时间'));
        } else {
          callback();
        }
      }
    };

    var tenderIsclosedTime = function tenderIsclosedTime(rule, value, callback) {
      if (value == '') {
        callback(new Error('保函购买截止时间'));
      } else {
        if (new Date(_this.ruleForm.tenderIsclosedTime).getTime() < new Date(value).getTime()) {
          callback(new Error('投标文件截止时间要超过保函购买截止时间'));
        } else if (new Date().getTime() > new Date(value).getTime()) {
          callback(new Error('请选择当天之后，不能选择当天时间'));
        } else {
          callback();
        }
      }
    };

    var tenderBone = function tenderBone(rule, value, callback) {
      if (value == '') {
        callback(new Error('请输入担保金额'));
      } else {
        if (Number(value) < 1) {
          callback(new Error('只能输入大于1的数字'));
        } else {
          callback();
        }
      }
    };

    return {
      dialogVisible: false,
      pickerOptionsEnd: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      feeId: '',
      //这个是收费标准的主键ID
      refundFee: 0,
      //这个是退费金额
      loading: false,
      showCreateNewFee: false,
      showSuccess: false,
      provinceList: [],
      cityList: [],
      fileList2: [],
      zhaoBiaoFile: '',
      proMode: [{
        label: '施工',
        value: 0,
        key: 'M4899'
      }, {
        label: '勘察',
        value: 1,
        key: 'M7483'
      }, {
        label: '设计',
        value: 2,
        key: 'M7484'
      }, {
        label: '监理',
        value: 3,
        key: 'M7482'
      }, {
        label: '总承包',
        value: 4,
        key: 'M4899'
      }],
      ruleForm: {
        notingNumber: '',
        notingName: '',
        proSerial: '',
        projectType: '',
        projectAddr: '',
        tenderIsclosedTime: '',
        validityOfBids: '',
        contractAmount: '',
        tenderBond: '',
        buyGuaranteeDeadline: '',
        tendereePerson: '',
        tendereeOperator: '',
        tendereeOperatorPhone: '',
        agency: '',
        agencyOperator: '',
        agencyOperatorPhone: '',
        tenderNoticeUrl: '',
        tenderDocumentUrl: '',
        projectProvince: '',
        //省
        projectCity: '',
        //市
        projectArea: '',
        //区
        guaranteeTemplateId: '',
        guaranteeTemplateName: '',
        bankEletterInstitutionName: '',
        address: '',
        guaranteeFee: ''
      },
      ruleFormDec: {
        notingNumber: '标段(包)编号',
        notingName: '标段(包)名称',
        proSerial: '报建编号',
        projectType: '项目类型',
        address: '项目所在地',
        projectAddr: '详细地址',
        tenderIsclosedTime: '投标文件递交截止日期',
        validityOfBids: '投标有效期(天)',
        buyGuaranteeDeadline: '保函购买截止时间',
        contractAmount: '项目金额(万元)',
        tenderBond: '保证金金额(万元)',
        guaranteeTemplateName: '保函模板',
        guaranteeFee: '保费金额(元)',
        bankEletterInstitutionName: '出函机构',
        tendereePerson: '招标人名称',
        tendereeOperator: '招标人经办人',
        tendereeOperatorPhone: '经办人联系电话',
        agency: '招标代理机构名称',
        agencyOperator: '招标代理机构经办人',
        agencyOperatorPhone: '招标代理机构联系电话',
        tenderNoticeUrl: '招标公告网址',
        tenderDocumentUrl: ''
      },
      areaId: {
        prbrcId: '',
        //项目地址Id
        cibrcId: '',
        //项目地址Id
        cobrcId: '' //项目地址Id

      },
      rules: (_rules = {
        agency: [{
          required: true,
          message: '请输入招标代理机构名称',
          trigger: 'blur'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('tsfh'),
          trigger: 'blur'
        }],
        tenderNoticeUrl: [{
          required: true,
          message: '请输入招标公告网址',
          trigger: 'blur'
        }],
        notingNumber: [{
          required: true,
          message: '请输入标段编号',
          trigger: 'blur'
        }],
        notingName: [{
          required: true,
          message: '请输入标段名称',
          trigger: 'blur'
        }],
        proSerial: [{
          // required: true,
          message: '请输入报建编号',
          trigger: 'blur'
        }],
        projectType: [{
          required: true,
          message: '请选择项目类型',
          trigger: 'change'
        }],
        tenderIsclosedTime: [{
          required: true,
          message: '请选择截止日期',
          trigger: 'blur'
        }],
        validityOfBids: [{
          required: true,
          message: '请输入投标有效期(天)',
          trigger: 'blur'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('tsfh'),
          trigger: 'blur'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('numb'),
          trigger: 'blur'
        }],
        tenderBond: [{
          required: true,
          message: '请输入投标保证金',
          trigger: 'blur'
        }, {
          validator: tenderBone
        }, {
          required: true,
          validator: this.publicMethed.regularTest('numb'),
          trigger: 'blur'
        }],
        contractAmount: [{
          required: true,
          message: '请输入项目金额',
          trigger: 'blur'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('numb'),
          trigger: 'blur'
        }],
        buyGuaranteeDeadline: [{
          required: true,
          validator: GuaranteeDeadline,
          trigger: 'blur'
        }],
        bankEletterInstitutionName: [{
          required: true,
          message: '请选择出函机构' // trigger: "blur",

        }, {
          required: true,
          validator: this.publicMethed.regularTest('tsfh'),
          trigger: 'blur'
        }],
        tendereePerson: [{
          required: true,
          message: '请输入招标人名称'
        }],
        guaranteeFee: [{
          required: true,
          message: '请输入保费'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('numb'),
          trigger: 'blur'
        }]
      }, _defineProperty(_rules, "agency", [{
        required: true,
        message: '请输入招标代理机构名称'
      }]), _defineProperty(_rules, "projectAddr", [{
        required: true,
        message: '请输入项目详细地址'
      }]), _defineProperty(_rules, "agencyOperatorPhone", [{
        required: true,
        validator: agencyOperatorPhone,
        trigger: 'blur'
      }]), _defineProperty(_rules, "guaranteeTemplateName", [{
        required: true,
        message: '请输入保函模版编号'
      }]), _rules),
      file: '',
      modelStyle: {
        loading: false,
        data: []
      },
      //保函模板
      bankListAll: [],
      //分支机构
      errorList: {},
      //非必填空的错误信息,,非必填，但填了必须填正确
      creatFeeData: {}
    };
  },
  watch: {
    area: function area(obj1, obj2) {
      if (obj1.brcId && obj1.brcId != '/') {
        this.$set(this.ruleForm, 'projectProvince', obj1.province);
        this.$set(this.ruleForm, 'projectCity', obj1.city);
        this.$set(this.ruleForm, 'projectArea', obj1.country == "不限区" ? '' : obj1.country);
        this.$set(this.ruleForm, 'address', this.ruleForm.projectProvince + this.ruleForm.projectCity + this.ruleForm.projectArea);
        var tem = obj1.brcId.split('_');
        this.areaId.prbrcId = tem[0];

        if (tem.length > 1 && tem[1] != '000000') {
          this.areaId.cibrcId = tem[1];
        }

        if (tem.length > 2 && tem[2] != '000000') {
          this.areaId.cobrcId = tem[2];
        }
      }
    },
    //监听保证金额 计算保费金额
    'ruleForm.tenderBond': function ruleFormTenderBond() {
      var _this2 = this;

      if (Number(this.ruleForm.tenderBond) > 80) {
        this.errorList = {
          tenderBond: '投标保证金金额不可超过80万'
        };
        return;
      }

      if (this.ruleForm.tenderBond === '') {
        return;
      }

      var data = {};
      var bId = '';

      if (this.areaId.prbrcId) {
        bId = this.areaId.prbrcId + '_';
      }

      if (this.areaId.cibrcId) {
        bId += this.areaId.cibrcId + '_';
      }

      if (this.areaId.cobrcId) {
        bId += this.areaId.cobrcId;
      }

      data['districtId'] = bId;
      data['page'] = 1;
      data['size'] = 5;
      data['tenderBond'] = this.ruleForm.tenderBond;
      data['enterpriseId'] = this.userInfo.enterpriseId;
      this.requestAPI.getFeeByGuaranteeId(data).then(function (res) {
        _this2.$set(_this2.ruleForm, 'guaranteeFee', res.data);
      }).catch(function () {
        _this2.$set(_this2.ruleForm, 'guaranteeFee', '');
      });
    }
  },
  computed: {
    bcrIdCum: function bcrIdCum() {
      // areaId: {
      // 	prbrcId: '', //项目地址Id
      // 	cibrcId: '', //项目地址Id
      // 	cobrcId: '', //项目地址Id
      // },
      var _str = '';

      for (var key in this.areaId) {
        if (this.areaId[key] != '') {
          _str = (_str == '' ? '' : _str + '_') + this.areaId[key];
        }
      }

      return _str;
    }
  },
  mounted: function mounted() {
    if (this.area && this.area.brcId && this.area.brcId != '/') {
      this.$set(this.ruleForm, 'projectProvince', this.area.province);
      this.$set(this.ruleForm, 'projectCity', this.area.city);
      this.$set(this.ruleForm, 'projectArea', this.area.country == "不限区" ? '' : this.area.country);
      this.$set(this.ruleForm, 'address', this.ruleForm.projectProvince + this.ruleForm.projectCity + this.ruleForm.projectArea);
      var tem = this.area.brcId.split('_');
      this.areaId.prbrcId = tem[0];

      if (tem.length > 1) {
        this.areaId.cibrcId = tem[1];
      }

      if (tem.length > 2) {
        this.areaId.cobrcId = tem[2];
      }
    }
  },
  created: function created() {
    this.templateUrl = ''; //保函模板地址

    this.fileObject = {};
    this.bankList = {
      orgName: '',
      orgNo: '',
      orgId: '',
      bankEletterAcctNo: '',
      acId: ''
    }; //选择的出函
  },
  methods: {
    focusDate: function focusDate() {
      this.$nextTick(function () {
        var list = document.querySelectorAll('.el-button--text');
        list.forEach(function (item, index) {
          item.style.display = 'none';
        });
      });
    },
    //获取省
    provinceChange: function provinceChange(value) {
      this.ruleForm.projectProvince = value.name;
      this.areaId.prbrcId = value.brcId;
    },
    //获取市
    cityChange: function cityChange(value) {
      this.ruleForm.projectCity = value.name;
      this.areaId.cibrcId = value.brcId;
    },
    //获取区
    countryChange: function countryChange(value) {
      var _this3 = this;

      this.ruleForm.projectArea = value.name;
      this.areaId.cobrcId = value.brcId;
      this.$set(this.ruleForm, 'address', this.ruleForm.projectProvince + this.ruleForm.projectCity + this.ruleForm.projectArea);

      if (this.ruleForm.tenderBond) {
        var data = {};
        data['province'] = this.ruleForm.projectProvince;
        data['city'] = this.ruleForm.projectCity;
        data['area'] = this.ruleForm.projectArea;
        data['page'] = 1;
        data['size'] = 5;
        data['tenderBond'] = this.ruleForm.tenderBond;
        data['enterpriseId'] = this.userInfo.enterpriseId;
        var bId = '';

        if (this.areaId.prbrcId) {
          bId = this.areaId.prbrcId + '_';
        }

        if (this.areaId.cibrcId) {
          bId += this.areaId.cibrcId + '_';
        }

        if (this.areaId.cobrcId) {
          bId += this.areaId.cobrcId;
        }

        data['districtId'] = bId;
        this.requestAPI.getFeeByGuaranteeId(data).then(function (res) {
          _this3.$set(_this3.ruleForm, 'guaranteeFee', res.data);
        }).catch(function () {
          _this3.$set(_this3.ruleForm, 'guaranteeFee', '');
        });
      }
    },
    // 本地文件直接下载，hadoop文件保证下载成功一次的情况下，只下载一次
    downAndCheck: function downAndCheck() {
      var _this4 = this;

      if (this.fileObject.url) {
        this.publicMethed.saveFileToLocal(this.fileObject.url, this.fileObject.name);
      } else {
        var data = {
          fileUrl: this.ruleForm.tenderDocumentUrl
        };
        this.publicMethed.downLoadImageC(data, function (res, type) {
          var _type = type.indexOf('image') != -1 ? '.png' : type.indexOf('pdf') != -1 ? '.pdf' : type.indexOf('zip') != -1 ? 'zip' : 'rar';

          _this4.publicMethed.saveFileToLocal(res, "\u62DB\u6807\u6587\u4EF6\u53CA\u5176\u4ED6\u6750\u6599".concat(_type));

          _this4.fileObject = {
            name: "\u62DB\u6807\u6587\u4EF6\u53CA\u5176\u4ED6\u6750\u6599".concat(_type),
            url: res
          };
        }, null);
      }
    },
    onChangeFile: function onChangeFile(file) {
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error("请勿上传超过8M的文件!");
        return;
      }

      var type = ['pdf', 'rar', 'zip', 'image', 'png', 'jpg', 'jpeg'];
      var bools = false;
      var result = file.name.split('.');

      for (var i = 0; i < type.length; i++) {
        if (type[i] == result[result.length - 1]) {
          bools = true;
        }
      }

      if (!bools) {
        this.$message.error("未能识别该文件类型!");
        return;
      }

      this.file = file;
      this.ruleForm.tenderDocumentUrl = URL.createObjectURL(file.raw); // 将名称，地址存一下，方便下载查看

      this.fileObject = {
        name: file.name,
        url: this.ruleForm.tenderDocumentUrl
      };
    },
    // 模板样式搜索回调
    remoteMethod: function remoteMethod(value) {
      var _this5 = this;

      var data = {
        templateNum: value,
        page: 1,
        size: 100
      };
      this.requestAPI.modelStyleQuery(data).then(function (res) {
        var tem = res.data;

        _this5.$set(_this5.modelStyle, 'data', tem.content);
      }).catch(function () {
        _this5.ruleForm.guaranteeTemplateName = '获取失败';
      });
    },
    // 模板样式回调
    modelStyleChange: function modelStyleChange(item) {
      this.ruleForm.guaranteeTemplateId = item.templateNum;
      this.ruleForm.guaranteeTemplateName = item.templateName;
      this.templateUrl = item.templateUrl;
    },
    // 预览模板样式
    previewTemplate: function previewTemplate() {
      var _this6 = this;

      if (this.templateUrl == '') {
        return;
      }

      if (this.templateUrl.indexOf('blob:') == -1) {
        this.loading = true;
        var data = {
          fileUrl: this.templateUrl
        };
        this.publicMethed.downLoadImageC(data, function (res) {
          _this6.loading = false;
          _this6.templateUrl = res;
          window.open('./pdf/web/viewer.html?file=' + res, "_blank");
        }, function () {
          _this6.loading = false;
        });
      } else {
        window.open('./pdf/web/viewer.html?file=' + this.templateUrl, "_blank");
      }
    },
    //出函机构选择
    bankChange: function bankChange(item) {
      this.bankList = item;
      this.ruleForm.bankEletterInstitutionName = item.orgName;
    },
    //点击出函机构前回调函数
    visibleChange: function visibleChange(value) {
      if (value) {
        if (this.ruleForm.projectArea == '') {
          this.$message.error('请先选择省市区！');
          return;
        } else {
          this.requestBank();
        }
      }
    },
    cancelShowFee: function cancelShowFee() {
      this.showCreateNewFee = false;
    },
    createSuccess: function createSuccess(value) {
      if (value == 2) {
        this.showCreateNewFee = false;
      }
    },
    SuccessCallBack: function SuccessCallBack() {
      this.showSuccess = false;

      for (var key in this.ruleForm) {
        this.$set(this.ruleForm, key, '');
      }

      this.$refs["ruleForm"].resetFields(); //移除校验结果并重置字段值
    },
    nextStepClick: function nextStepClick() {
      var _this7 = this;

      //区分角色 担保机构创建项目 直接提交 渠道的话就下一步
      //0824 新流程  渠道，担保机构都创建项目,审核完成后渠道选择投标企业
      if (!this.file && !this.ruleForm.tenderDocumentUrl) {
        this.$message({
          message: '请选择招标文件及其他资料',
          type: 'error'
        });
        return;
      }

      if (this.ruleForm.address == '') {
        this.$message.error('请选择项目所在地');
        return;
      }

      if (Number(this.ruleForm.contractAmount) < Number(this.ruleForm.tenderBond)) {
        this.$message.error('项目总金额要大于投标保证金金额！');
        return;
      }

      if (Number(this.ruleForm.tenderBond) > 80) {
        this.errorList = {
          tenderBond: '投标保证金金额不可超过80万'
        };
        this.$message.error('投标保证金金额不可超过80万');
        return;
      }

      if (this.ruleForm.guaranteeTemplateId == '') {
        this.errorList = {
          guaranteeTemplateId: '请输入保函模版编号'
        };
        this.$message.error('请输入保函模版编号');
        return;
      }

      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          // 11位到13位号码 连接符（-） 包括座机  暂未判断连接符位置
          _this7.loading = true;
          setTimeout(function () {
            _this7.loading = false;
          }, 120000);
          new Promise(function (resolve, reject) {
            if (_this7.ruleForm.tenderDocumentUrl.indexOf('blob:') == -1) {
              resolve(_this7.ruleForm.tenderDocumentUrl);
            } else {
              var url = ''; //hadoop 上传文件

              var flowNum = _this7.userInfo.creditCode;
              var fileType = 'e' + new Date().getTime();
              var fileNum = 3;

              _this7.publicMethed.upLoadImageC(_this7.file, flowNum, fileType, fileNum, function (res) {
                resolve(res);
              });
            }
          }).then(function (res) {
            // projectSource  1：担保机构  2：渠道  3，内管
            var data = {
              projectSource: _this7.userInfo.userType == 2 ? 1 : 2,
              notingName: _this7.ruleForm.notingName,
              notingNumber: _this7.ruleForm.notingNumber,
              auditStatus: 1,
              projectType: _this7.ruleForm.projectType,
              proSerial: _this7.ruleForm.proSerial,
              bcrId: _this7.areaId.prbrcId + '_' + _this7.areaId.cibrcId + '_' + _this7.areaId.cobrcId,
              projectProvince: _this7.ruleForm.projectProvince,
              projectCity: _this7.ruleForm.projectCity,
              projectArea: _this7.ruleForm.projectArea,
              projectAddr: _this7.ruleForm.projectAddr,
              tenderIsclosedTime: _this7.publicMethed.formatDateTime(_this7.ruleForm.tenderIsclosedTime),
              validityOfBids: _this7.ruleForm.validityOfBids,
              contractAmount: _this7.ruleForm.contractAmount,
              tenderBond: _this7.ruleForm.tenderBond,
              buyGuaranteeDeadline: _this7.publicMethed.formatDateTime(_this7.ruleForm.buyGuaranteeDeadline),
              tendereePerson: _this7.ruleForm.tendereePerson,
              tendereeOperator: _this7.ruleForm.tendereeOperator,
              tendereeOperatorPhone: _this7.ruleForm.tendereeOperatorPhone,
              agency: _this7.ruleForm.agency,
              agencyOperator: _this7.ruleForm.agencyOperator,
              agencyOperatorPhone: _this7.ruleForm.agencyOperatorPhone,
              tenderNoticeUrl: _this7.ruleForm.tenderNoticeUrl,
              tenderDocumentUrl: res,
              userId: _this7.userInfo.userId,
              pfCreateId: _this7.userInfo.userId,
              pfCreateName: _this7.userInfo.userName,
              pfCreateEnterprise: _this7.userInfo.enterpriseName,
              companyId: _this7.userInfo.enterpriseId,
              guaranteeName: _this7.userInfo.enterpriseName,
              guaranteeFee: _this7.ruleForm.guaranteeFee,
              // 新增
              guaranteeTemplateId: _this7.ruleForm.guaranteeTemplateId,
              guaranteeTemplateName: _this7.ruleForm.guaranteeTemplateName,
              bankEletterInstitutionName: _this7.bankList.orgName,
              bankEletterInstitution: _this7.bankList.orgNo,
              bankEletterAcctNo: _this7.bankList.bankEletterAcctNo,
              bankEletterAcctName: _this7.bankList.orgName,
              feeId: _this7.feeId,
              refundFee: _this7.refundFee,
              projectGuarantees: [{
                orgId: _this7.bankList.orgId,
                acId: _this7.bankList.acId
              }]
            };

            if (_this7.userInfo.userType == 3) {
              data['guaranteeId'] = _this7.userInfo.relatedGranrantee;
            } else if (_this7.userInfo.userType == 2) {
              data['guaranteeId'] = _this7.userInfo.enterpriseId;
            }

            if (_this7.$route.query.id) {
              data['bankFlag'] = _this7.ruleForm.bankFlag;
              data['auditStatus'] = _this7.ruleForm.auditStatus;
              data['projectId'] = _this7.$route.query.id; // data['type'] = bools   //0:变更，projectNo+1 ，1：重新提交 相同

              _this7.requestAPI.updateProject(data).then(function (res) {
                _this7.loading = false;
                _this7.showSuccess = true;
              }).catch(function () {
                _this7.loading = false;
              });
            } else {
              _this7.requestAPI.addProject(data).then(function (res) {
                _this7.loading = false;
                _this7.showSuccess = true;
              }).catch(function () {
                _this7.loading = false;
              });
            }
          });
        }
      });
    },
    cancelFun: function cancelFun() {
      this.$router.go(-1);
    },
    // input(obj) {
    // 	this.ruleForm.projectProvince = obj.curProvince
    // 	this.ruleForm.projectCity = obj.curCity
    // 	this.ruleForm.projectArea = obj.curCountry
    // },
    requestBank: function requestBank() {
      var _this8 = this;

      var data = {};
      data['bcrId'] = this.areaId.cobrcId;

      if (this.userInfo.userType == 2) {
        data['guaranteeId'] = this.userInfo.enterpriseId;
      } else if (this.userInfo.userType == 3) {
        data['guaranteeId'] = this.userInfo.relatedGranrantee;
      }

      this.requestAPI.selOrgletterByLike(data).then(function (res) {
        var tem = res.data;
        _this8.bankListAll = tem;
      }).catch(function () {
        _this8.bankEletterInstitution = -1;
        _this8.ruleForm.bankEletterInstitutionName = '获取失败';

        _this8.$message.error('查询出函机构出错!');
      });
    }
  },
  activated: function activated() {
    var _this9 = this;

    if (this.$route.query.id) {
      this.requestAPI.singleProject({
        projectId: this.$route.query.id
      }).then(function (res) {
        // console.log(res, '获取详情')
        if (res.errorCode == '0000') {
          var data = res.data[0];

          for (var key in data) {
            // if(data.hasOwnProperty(key)){
            _this9.$set(_this9.ruleForm, key, data[key]); // }

          }

          var projectType = '';

          if (data.projectType == 0) {
            projectType = '施工';
          } else if (data.projectType == 1) {
            projectType = '勘察';
          } else if (data.projectType == 2) {
            projectType = '设计';
          } else if (data.projectType == 3) {
            projectType = '监理';
          } else if (data.projectType == 4) {
            projectType = '总承包';
          } // this.ruleForm.notingNumber = data.notingNumber
          // this.ruleForm.notingName = data.notingName
          // this.ruleForm.proSerial = data.proSerial


          _this9.$set(_this9.ruleForm, 'projectType', data.projectType); // this.ruleForm.projectType = data.projectType
          // this.ruleForm.projectAddr = data.projectAddr


          _this9.$set(_this9.ruleForm, 'address', data.projectProvince + data.projectCity + data.projectArea); // this.ruleForm.address = data.projectProvince + data.projectCity + data.projectArea
          // this.ruleForm.projectProvince = data.projectProvince, //省
          // 	this.ruleForm.projectCity = data.projectCity, //市
          // 	this.ruleForm.projectArea = data.projectArea, //区


          _this9.$set(_this9.ruleForm, 'tenderIsclosedTime', new Date(data.tenderIsclosedTime.replace(/-/g, '/'))); // this.ruleForm.tenderIsclosedTime = new Date(data.tenderIsclosedTime.replace(/-/g, '/'))
          // this.ruleForm.validityOfBids = data.validityOfBids


          _this9.$set(_this9.ruleForm, 'buyGuaranteeDeadline', new Date(data.buyGuaranteeDeadline.replace(/-/g, '/'))); // this.ruleForm.buyGuaranteeDeadline = new Date(data.buyGuaranteeDeadline.replace(/-/g, '/'))
          // this.ruleForm.contractAmount = data.contractAmount
          // this.ruleForm.tenderBond = data.tenderBond
          // this.ruleForm.guaranteeTemplateName = data.guaranteeTemplateName
          // this.ruleForm.guaranteeFee = data.guaranteeFee
          // this.ruleForm.bankEletterInstitutionName = data.bankEletterAcctName
          // this.ruleForm.tendereePerson = data.tendereePerson
          // this.ruleForm.tendereeOperator = data.tendereeOperator
          // this.ruleForm.tendereeOperatorPhone = data.tendereeOperatorPhone || ''
          // this.ruleForm.agency = data.agency
          // this.ruleForm.agencyOperator = data.agencyOperator
          // this.ruleForm.agencyOperatorPhone = data.agencyOperatorPhone || ''
          // this.ruleForm.tenderNoticeUrl = data.tenderNoticeUrl
          // this.ruleForm.tenderDocumentUrl = data.tenderDocumentUrl
          // this.bankList.orgName = data.orgName
          // this.bankList.orgNo = data.bankEletterInstitution
          // this.bankList.orgId = data.orgId
          // this.bankList.bankEletterAcctNo = data.bankEletterAcctNo
          // this.bankList.acId = data.acId


          for (var _key in _this9.bankList) {
            if (data.hasOwnProperty(_key)) {
              _this9.$set(_this9.bankList, _key, data[_key]);
            } else if (_key == 'orgNo') {
              _this9.$set(_this9.bankList, _key, data.bankEletterInstitution);
            }
          }

          _this9.refundFee = data.refundFee;
          var bcrId = data.bcrId;
          var result = bcrId.split("_");
          _this9.areaId.prbrcId = result[0];
          _this9.areaId.cibrcId = result[1];
          _this9.areaId.cobrcId = result[2]; // this.ruleForm.guaranteeTemplateId = data.guaranteeTemplateId
          // this.ruleForm.auditStatus = data.auditStatus
          // this.ruleForm.bankFlag = data.bankFlag
        }
      });
    } else {// for (let key in this.ruleForm) {
      // 	this.ruleForm[key] = ''
      // }
      // for (let key in this.bankList) {
      // 	this.bankList[key] = ''
      // }
      // for (let key in this.areaId) {
      // 	this.areaId[key] = ''
      // }
      // this.dialogVisible = false
    }
  }
};